import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { TypedMemo } from '../../../common/types';
import { formatMonth } from '../streamingFormat';
import { streamingPeriodMessages as messages } from '../streamingPeriodMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import shared from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the period sections; each part uses its own slice of it */
import styles from '../StreamingPeriod.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SectionMonthLineProps {
  /** "TuneCore gives age and gender per month." */
  text: string;
  /** The line after it, or undefined for the default line of the months. */
  shown?: string;
  months: readonly string[];
  /** Audience: the month shown and the select of the months (design a2). */
  month?: string | null;
  onPickMonth?: (month: string) => void;
}

/** The line that says which months a monthly source covers (design streaming-sections a1, b1). */
const SectionMonthLineComponent: React.FC<SectionMonthLineProps> = ({ text, shown, months, month, onPickMonth }) => {
  const intl = useIntl();
  const monthNames = useMemo(() => months.map((one) => formatMonth(intl, one)), [intl, months]);
  const defaultShown =
    months.length === 0
      ? intl.formatMessage(messages.monthsNone)
      : intl.formatMessage(messages.monthsShown, { months: intl.formatList(monthNames, { type: 'conjunction' }) });
  const hasSelect = onPickMonth !== undefined && months.length > 1 && month !== undefined && month !== null;

  return (
    <div className={styles.monthLine} data-testid="streaming-month-line">
      <FontAwesomeIcon icon={faCircleInfo} />
      <span>{text}</span>
      <span>{shown ?? defaultShown}</span>
      {hasSelect ? (
        <select
          className={shared.select}
          aria-label={intl.formatMessage(messages.monthLabel)}
          value={month ?? undefined}
          onChange={(event) => onPickMonth?.(event.target.value)}
        >
          {[...months].reverse().map((one) => (
            <option key={one} value={one}>
              {formatMonth(intl, one)}
            </option>
          ))}
        </select>
      ) : null}
    </div>
  );
};

export const SectionMonthLine = TypedMemo(SectionMonthLineComponent);
